import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { n_ai_speaking, n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

export const RoleplayCompletePopup = ({ showCompleteModal, setShowCompleteModal, onClickThreadSummary }) => {
  const { t } = useTranslation()

  return (
    <DSModal
      id="conversationErrorModal"
      isOpen={showCompleteModal}
      setIsOpen={setShowCompleteModal}
      size={'sm'}
      closeButton={false}
    >
      <DSModal.Title className="keep-all">{t(n_ai_speaking.popup_exit2.title)}</DSModal.Title>
      <DSModal.Content className="">{t(n_ai_speaking.popup_exit2.body)}</DSModal.Content>

      <DSModal.ButtonContainer direction="horizontal">
        {/* 팝업만 끄기 */}
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.OUTLINE} onClick={() => setShowCompleteModal(false)}>
          <DSButton.Label>{t(n_ai_tutor.roleplay_popup.btn1)}</DSButton.Label>
        </DSButton>
        {/* 세션 요약하기 */}
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={() => onClickThreadSummary()}>
          <DSButton.Label>{t(n_ai_tutor.roleplay_popup.btn2)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default RoleplayCompletePopup
